import { Grid, MenuItem, Divider } from "@mui/material";
import {
  RHFRoundedSelect,
  RHFRoundedTextField,
  RHFUpload,
} from "../../../components/minimal/hook-form";
import { IFormProps } from "types/form-props";
import { DOMAIN_OPTIONS, TYPE_OPTIONS } from "./badge-column";

interface BadgeFormProps extends IFormProps {}

const BadgeForm: React.FC<BadgeFormProps> = ({ currentItem, setValue }) => {
  return (
    <>
      <Grid item xs={6}>
        <RHFRoundedSelect
          name="type"
          size="small"
          label="Type"
          disabled={!!currentItem}
        >
          <MenuItem
            // value={noSelectedValue}
            // onClick={() => handleClearService(index)}
            sx={{ fontStyle: "italic", color: "text.secondary" }}
          >
            None
          </MenuItem>
          <Divider sx={{ borderStyle: "dashed" }} />
          {TYPE_OPTIONS.map((item: any) => (
            <MenuItem key={item.id} value={item.id}>
              {true ? item.value : item.title}
            </MenuItem>
          ))}
        </RHFRoundedSelect>
      </Grid>
      <Grid item xs={6}>
        <RHFRoundedSelect
          name="domain"
          size="small"
          label="Domain"
          disabled={!!currentItem}
        >
          <MenuItem>None</MenuItem>
          <Divider sx={{ borderStyle: "dashed" }} />
          {DOMAIN_OPTIONS.map((item: any) => (
            <MenuItem key={item.id} value={item.id}>
              {true ? item.value : item.title}
            </MenuItem>
          ))}
        </RHFRoundedSelect>
      </Grid>
      <Grid item xs={6}>
        <RHFRoundedTextField name="title" label="Title (En)" />
      </Grid>

      <Grid item xs={6}>
        <RHFRoundedTextField name="titleAr" label="Title (Ar)" />
      </Grid>
      {currentItem && (
        <>
          <Grid item xs={6}>
            <RHFRoundedTextField
              name="description"
              label="Description (En)"
              disabled
            />
          </Grid>

          <Grid item xs={6}>
            <RHFRoundedTextField
              name="descriptionAr"
              label="Description (Ar)"
              disabled
            />
          </Grid>
        </>
      )}

      <Grid item xs={6}>
        <RHFRoundedTextField name="totalCount" label="Total Count" />
      </Grid>
      <Grid item xs={12}>
        <RHFUpload //Replace to RHFUpload
          name="coverImage"
          // file={file}
          onDrop={(acceptedFiles) => {
            const newFile = Object.assign(acceptedFiles[0], {
              preview: URL.createObjectURL(acceptedFiles[0]),
            });
            setValue("coverImage", newFile);
          }}
        />
      </Grid>
    </>
  );
};

export default BadgeForm;
